import { render, staticRenderFns } from "./AffectedSalepointsDialog.vue?vue&type=template&id=007a0cab&scoped=true&"
import script from "./AffectedSalepointsDialog.vue?vue&type=script&lang=js&"
export * from "./AffectedSalepointsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007a0cab",
  null
  
)

export default component.exports